<template>
  <div
    v-if="status !== 'failed'"
    class="mt-2 py-2 px-1 ai-extracted-questions"
  >
    <div class="d-flex align-center mb-1 ai-extracted-questions__header">
      <b class="d-flex text-correctionBlue align-center">
        <RobotIcon class="svg-correctionBlue-fill" />
        <span style="line-height: 20px;">AIが相談文から抽出した疑問</span>
      </b>
      <v-btn
        v-if="hasExtractedQuestions"
        class="ml-auto my-0"
        :color="isOpen ? null : 'grey-darken-4'"
        density="comfortable"
        outlined
        size="small"
        @click="toggleOpen"
      >
        {{ isOpen ? "閉じる▲" : "開く▼" }}
      </v-btn>
      <template v-else>
        <div
          v-if="status === 'fetching' || status === 'polling'"
          class="ml-auto pr-2"
        >
          <v-progress-circular
            indeterminate
            color="correctionBlue"
            size="16"
            width="2"
            class="correction-tab__status-spinner"
          />
          抽出中
        </div>
      </template>
    </div>

    <template v-if="status === 'completed'">
      <div
        v-if="!hasExtractedQuestions"
        class="pa-2"
      >
        この相談文からは、明確な疑問点が見つかりませんでした。
      </div> 
      <div
        v-else-if="isOpen"
        class="ai-extracted-questions__list"
      >
        <div
          v-for="question in extractedQuestions"
          :key="question.id"
          :class="[
            'ai-extracted-questions__item',
            { 'ai-extracted-questions__item--selected': isQuestionSelected(question) }
          ]"
        >
          <div class="ai-extracted-questions__content">
            <div class="ai-extracted-questions__question">
              {{ question.question }}
            </div>
            <div
              v-if="question.quote"
              class="ai-extracted-questions__quote"
            >
              [引用] <span class="ai-extracted-questions__quote-text">{{ question.quote }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RobotIcon from "@/vue/components/images/robotIcon.vue";

export default {
  name: "AnytimeConsultationExtractedQuestions",
  components: {
    RobotIcon,
  },
  data: () => ({
    isOpen: false,
  }),
  computed: {
    ...mapGetters({
      extractedQuestions: "consultationExtractedQuestions",
      status: "consultationPreprocessingStatus",
      hasExtractedQuestions: "hasExtractedQuestions",
      selectedUnansweredQuestionId: "selectedUnansweredQuestionId",
    }),
  },
  watch: {
    selectedUnansweredQuestionId(newVal) {
      if (newVal && !this.isOpen) {
        this.isOpen = true;
      }
      this.scrollSelectedQuestionIntoView();
    },
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
    isQuestionSelected(question) {
      if (!this.selectedUnansweredQuestionId) return false;
      return String(question.id) === String(this.selectedUnansweredQuestionId);
    },
    scrollSelectedQuestionIntoView() {
      this.$nextTick(() => {
        if (!this.selectedUnansweredQuestionId) return;

        const inquiryElement = document.querySelector(
          ".anytime-consultation-inquiry"
        );

        if (!inquiryElement) return;

        inquiryElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      });
    },
  },
};
</script>

<style lang="scss">
.ai-extracted-questions {
  background: #E8F2FE;
  border-radius: 12px;

  &__list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-left: 2px;
  }

  &__item {
    display: flex;
    align-items: flex-start;
    background-color: #ffffff;
    border: 1px solid #c7d9f8;
    border-radius: 8px;
    padding: 10px 12px;
    box-shadow: 0 1px 2px rgba(17, 24, 39, 0.08);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  &__item--selected {
    background-color: #ffecef;
  }

  &__content {
    flex: 1;
  }

  &__question {
    font-weight: 700;
    font-size: 13px;
    color: #0f172a;
    margin-bottom: 4px;
  }

  &__quote {
    font-size: 13px;
    color: #475569;
    line-height: 1.4;

    &-text {
      border-bottom: 2px dotted #ccc;
    }
  }

  &__message {
    background: #ffffff;
    border-radius: 8px;
    padding: 12px;
    margin-left: 2px;
    border: 1px dashed #94a3b8;
  }
}
</style>
